var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddComment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.965 18.13c.407 0 .69-.216 1.196-.665l2.863-2.548h5.33c2.473 0 3.801-1.37 3.801-3.802V4.757c0-2.432-1.328-3.802-3.802-3.802H4.664C2.187.955.86 2.316.86 4.757v6.358c0 2.44 1.328 3.802 3.802 3.802h.399v2.158c0 .64.323 1.054.904 1.054Zm.34-1.52v-2.407c0-.448-.174-.622-.622-.622h-1.02c-1.678 0-2.466-.855-2.466-2.474v-6.35c0-1.619.788-2.465 2.465-2.465h10.692c1.668 0 2.465.846 2.465 2.465v6.35c0 1.619-.797 2.474-2.465 2.474h-5.38c-.464 0-.697.066-1.012.39l-2.656 2.64Zm-.14-8.674c0 .407.29.68.713.68h2.44v2.45c0 .414.283.705.682.705.423 0 .705-.282.705-.706V8.617h2.449c.415 0 .705-.274.705-.681 0-.415-.282-.706-.705-.706h-2.449V4.79c0-.423-.282-.714-.705-.714-.399 0-.681.29-.681.714v2.44h-2.44c-.424 0-.714.291-.714.706Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddComment);
export default __webpack_public_path__ + "static/media/addComment.c9ea2ba86e650afa97c0ba8621dad7db.svg";
export { ForwardRef as ReactComponent };